import { NextSeo } from 'next-seo';
import React from 'react';
import Container from '../components/Container';
import PageHeader from '../components/PageHeader';
import TheVendingMachinePage from '../components/TheVendingMachinePage';
import VendingBuysFeed from '../components/VendingBuysFeed';
import { VendingMachineNfdCallout } from '../components/VendingMachineNfdCallout';
import config from '../config';

function VendingMachinePage() {
  const description = `Spend Shitty Treats to try and win a random NFT from the Shitty Vending Machine.`;

  return (
    <>
      <NextSeo title={`Shitty Vending Machine - ${config.siteName}`} description={description} />

      <div className='pb-12 md:pb-48 bg-bg'>
        <PageHeader
          heading={'Shitty Vending Machine'}
          description={description}
          docsLink={'https://docs.shittykitties.art/website-utilities/shitty-vending-machine'}
        />

        <Container>
          <TheVendingMachinePage />
          <VendingBuysFeed />
          <VendingMachineNfdCallout />
        </Container>
      </div>
    </>
  );
}

export default VendingMachinePage;
